import { render, staticRenderFns } from "./ToTopButton.vue?vue&type=template&id=42aac10e&scoped=true"
import script from "./ToTopButton.vue?vue&type=script&lang=js"
export * from "./ToTopButton.vue?vue&type=script&lang=js"
import style0 from "./ToTopButton.vue?vue&type=style&index=0&id=42aac10e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aac10e",
  null
  
)

export default component.exports